import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo-pdf.png'


const _hoisted_1 = {
  class: "my-table-section profile-table",
  ref: "profileTable"
}
const _hoisted_2 = { class: "my-table-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-title" }, "Profile", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "my-table-row" }
const _hoisted_6 = {
  key: 0,
  class: "the-col flex-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, " I am enrolling on behalf of my spouse or child ", -1)
const _hoisted_8 = { class: "the-value" }
const _hoisted_9 = { class: "the-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "First Name", -1)
const _hoisted_11 = { class: "the-value" }
const _hoisted_12 = { class: "the-col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Last Name", -1)
const _hoisted_14 = { class: "the-value" }
const _hoisted_15 = { class: "the-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "SSN", -1)
const _hoisted_17 = { class: "the-value the-number" }
const _hoisted_18 = { class: "my-table-row" }
const _hoisted_19 = { class: "the-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Date Of Birth", -1)
const _hoisted_21 = { class: "the-value the-number" }
const _hoisted_22 = { class: "the-col flex-2 d-flex email-gender" }
const _hoisted_23 = { class: "the-col me-md-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Email", -1)
const _hoisted_25 = { class: "the-value" }
const _hoisted_26 = { class: "the-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Gender", -1)
const _hoisted_28 = { class: "the-value" }
const _hoisted_29 = { class: "the-col" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Phone Number", -1)
const _hoisted_31 = { class: "the-value the-number" }
const _hoisted_32 = { class: "the-col" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Country", -1)
const _hoisted_34 = { class: "the-value" }
const _hoisted_35 = { class: "my-table-row" }
const _hoisted_36 = { class: "the-col flex-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Address", -1)
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = {
  key: 0,
  class: "the-col"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "City", -1)
const _hoisted_41 = { class: "the-value" }
const _hoisted_42 = {
  key: 1,
  class: "the-col"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "State", -1)
const _hoisted_44 = { class: "the-value" }
const _hoisted_45 = {
  key: 2,
  class: "the-col"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Zip Code", -1)
const _hoisted_47 = { class: "the-value the-number" }
const _hoisted_48 = {
  key: 0,
  class: "my-table-section beneficiary-table",
  ref: "qualifyingBeneficiaryTable"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "my-table-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-table-title" }, "Qualifying Beneficiary")
], -1)
const _hoisted_50 = { class: "my-table-row" }
const _hoisted_51 = { class: "the-col" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "First Name", -1)
const _hoisted_53 = { class: "the-value" }
const _hoisted_54 = { class: "the-col" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Last Name", -1)
const _hoisted_56 = { class: "the-value" }
const _hoisted_57 = { class: "the-col" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "SSN", -1)
const _hoisted_59 = { class: "the-value the-number" }
const _hoisted_60 = { class: "my-table-header" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-title" }, "Dependents", -1)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 0,
  class: "my-table-row"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, "No dependents found.", -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "the-col dep-profile" }
const _hoisted_67 = { class: "dep-name" }
const _hoisted_68 = { class: "dep-relation" }
const _hoisted_69 = { class: "the-col" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Date Of Birth", -1)
const _hoisted_71 = { class: "the-value the-number" }
const _hoisted_72 = { class: "the-col" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "SSN", -1)
const _hoisted_74 = { class: "the-value the-number" }
const _hoisted_75 = { class: "the-col" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Gender", -1)
const _hoisted_77 = { class: "the-value" }
const _hoisted_78 = {
  key: 1,
  src: _imports_0,
  class: "pdf-logo"
}
const _hoisted_79 = { class: "my-table-header" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-title" }, "Benefits", -1)
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 0,
  class: "my-table-row"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "no-data-benefits" }, "No benefits were elected.", -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = {
  key: 2,
  src: _imports_0,
  class: "pdf-logo"
}
const _hoisted_88 = { class: "my-table-header" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-title" }, "Payments", -1)
const _hoisted_90 = { key: 0 }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-subtitle" }, " Initial payment method for enrollment ", -1)
const _hoisted_92 = { class: "benefit-row" }
const _hoisted_93 = { class: "my-table-row" }
const _hoisted_94 = { class: "the-col" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Amount Due Today", -1)
const _hoisted_96 = { class: "the-value the-number total-amount" }
const _hoisted_97 = {
  key: 0,
  class: "the-col"
}
const _hoisted_98 = { class: "the-verbiage the-number total-amount" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Payment Method", -1)
const _hoisted_100 = { class: "the-value the-number" }
const _hoisted_101 = {
  key: 0,
  class: "the-col"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Card Type", -1)
const _hoisted_103 = { class: "the-value card-type" }
const _hoisted_104 = {
  key: 1,
  class: "the-col"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Last 4 Digits", -1)
const _hoisted_106 = { class: "the-value" }
const _hoisted_107 = {
  key: 0,
  class: "my-table-row"
}
const _hoisted_108 = { class: "the-col" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Routing Number", -1)
const _hoisted_110 = { class: "the-value the-number" }
const _hoisted_111 = { class: "the-col" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Bank Name", -1)
const _hoisted_113 = { class: "the-value bank-name" }
const _hoisted_114 = { class: "the-col" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Account Number", -1)
const _hoisted_116 = { class: "the-value the-number" }
const _hoisted_117 = { class: "the-col" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Account Holder Name", -1)
const _hoisted_119 = { class: "the-value" }
const _hoisted_120 = { class: "the-col" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Account Type", -1)
const _hoisted_122 = { class: "the-value" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-subtitle" }, "Recurring payment method", -1)
const _hoisted_124 = { class: "benefit-row" }
const _hoisted_125 = { class: "my-table-row" }
const _hoisted_126 = { class: "the-col" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Monthly Premium", -1)
const _hoisted_128 = { class: "the-value the-number total-amount" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Payment Method", -1)
const _hoisted_130 = { class: "the-value the-number" }
const _hoisted_131 = {
  key: 0,
  class: "the-col"
}
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Card Type", -1)
const _hoisted_133 = { class: "the-value card-type" }
const _hoisted_134 = {
  key: 1,
  class: "the-col"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Last 4 Digits", -1)
const _hoisted_136 = { class: "the-value" }
const _hoisted_137 = {
  key: 0,
  class: "my-table-row"
}
const _hoisted_138 = { class: "the-col" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Routing Number", -1)
const _hoisted_140 = { class: "the-value the-number" }
const _hoisted_141 = { class: "the-col" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Bank Name", -1)
const _hoisted_143 = { class: "the-value bank-name" }
const _hoisted_144 = { class: "the-col" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Account Number", -1)
const _hoisted_146 = { class: "the-value the-number" }
const _hoisted_147 = { class: "the-col" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Account Holder Name", -1)
const _hoisted_149 = { class: "the-value" }
const _hoisted_150 = { class: "the-col" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Account Type", -1)
const _hoisted_152 = { class: "the-value" }
const _hoisted_153 = {
  key: 1,
  class: "my-table-row"
}
const _hoisted_154 = { class: "the-col" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Country", -1)
const _hoisted_156 = { class: "the-value" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Address", -1)
const _hoisted_158 = ["innerHTML"]
const _hoisted_159 = {
  key: 0,
  class: "the-col"
}
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "City", -1)
const _hoisted_161 = { class: "the-value" }
const _hoisted_162 = {
  key: 1,
  class: "the-col"
}
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "State", -1)
const _hoisted_164 = { class: "the-value" }
const _hoisted_165 = {
  key: 2,
  class: "the-col"
}
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Zip Code", -1)
const _hoisted_167 = { class: "the-value the-number" }
const _hoisted_168 = {
  key: 4,
  src: _imports_0,
  class: "pdf-logo"
}
const _hoisted_169 = { class: "my-table-header" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "page-table-title" }, "Documents", -1)
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { class: "my-table-row" }
const _hoisted_173 = {
  key: 0,
  class: "no-data"
}
const _hoisted_174 = { class: "doc-icon" }
const _hoisted_175 = ["alt", "src"]
const _hoisted_176 = { class: "doc-info" }
const _hoisted_177 = { class: "doc-title" }
const _hoisted_178 = { class: "doc-name" }
const _hoisted_179 = { class: "doc-details" }
const _hoisted_180 = { class: "doc-size" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "upload-complete" }, "Uploaded", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationCOBRAEnrollmentBenefit = _resolveComponent("ConfirmationCOBRAEnrollmentBenefit")!
  const _component_ConfirmationOpenEnrollmentBenefit = _resolveComponent("ConfirmationOpenEnrollmentBenefit")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["confirmation-table", _ctx.$route.name])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.modifyBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                class: "edit-pencil modalopen btn-link",
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectProfilePage()))
              }, "Modify")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.enrollmentType == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.profileData.originalEmployee ? "No" : "Yes"), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.profileData.firstName), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.profileData.lastName), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.profileData.ssn), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.profileData.dob!)), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.profileData.emailAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.helper.getGenderLabels(_ctx.profileData.genderId!)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.profileData.phoneNumber), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.getCountryName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("div", {
            class: "the-value pe-md-2",
            innerHTML: _ctx.formatAddress(_ctx.profileData.address1!, _ctx.profileData.address2!)
          }, null, 8, _hoisted_38)
        ]),
        (_ctx.profileData.countryId !== _ctx.countries.OTH)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.profileData.city), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.profileData.countryId !== _ctx.countries.OTH)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.getStateName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.profileData.countryId !== _ctx.countries.OTH)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.profileData.zipCode), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512),
    (!_ctx.profileData.originalEmployee)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.qualifyingBeneficiaryData.firstName), 1)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.qualifyingBeneficiaryData.lastName), 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.qualifyingBeneficiaryData.ssn), 1)
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["my-table-section", { 'html2pdf__page-break': _ctx.dependentsPaginate }]),
      ref: "dependentsTable"
    }, [
      _createElementVNode("div", _hoisted_60, [
        _hoisted_61,
        (_ctx.modifyBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createElementVNode("a", {
                class: "edit-pencil modalopen btn-link",
                role: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectDependentPage()))
              }, "Modify")
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.dependentData.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dependentData, (dependent) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "my-table-row",
          key: dependent.electionDependentId
        }, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, _toDisplayString(dependent.firstName) + " " + _toDisplayString(dependent.lastName), 1),
            _createElementVNode("div", _hoisted_68, _toDisplayString(dependent.relationshipName), 1)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.formatDate(dependent.dob!)), 1)
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, _toDisplayString(dependent.ssn), 1)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, _toDisplayString(dependent.genderName), 1)
          ])
        ]))
      }), 128))
    ], 2),
    (_ctx.dependentsPaginate)
      ? (_openBlock(), _createElementBlock("img", _hoisted_78))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["my-table-section benefit-section", {
        'html2pdf__page-break': _ctx.benefitsPaginate,
        openEnrollmentBenefits: _ctx.enrollmentType == 1,
      }]),
      ref: "benefitsTable"
    }, [
      _createElementVNode("div", _hoisted_79, [
        _hoisted_80,
        (_ctx.modifyBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
              _createElementVNode("a", {
                class: "edit-pencil modalopen btn-link",
                role: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectBnefitPage()))
              }, "Modify")
            ]))
          : _createCommentVNode("", true)
      ]),
      (
          _ctx.benefitsData.length === 0 &&
          _ctx.openEnrollmentUnbundledBenefits.length === 0 &&
          _ctx.openEnrollmentBundles.length === 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
        : _createCommentVNode("", true),
      (_ctx.enrollmentType == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefitsData, (benefit, index) => {
              return (_openBlock(), _createBlock(_component_ConfirmationCOBRAEnrollmentBenefit, {
                key: index,
                benefit: benefit,
                dependentData: _ctx.dependentData
              }, null, 8, ["benefit", "dependentData"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.enrollmentType == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openEnrollmentUnbundledBenefits, (data, key) => {
              return (_openBlock(), _createBlock(_component_ConfirmationOpenEnrollmentBenefit, {
                key: key,
                unbundledBenefit: data,
                dependentData: _ctx.dependentData
              }, null, 8, ["unbundledBenefit", "dependentData"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openEnrollmentBundles, (data, key) => {
              return (_openBlock(), _createBlock(_component_ConfirmationOpenEnrollmentBenefit, {
                key: key,
                bundle: data,
                dependentData: _ctx.dependentData
              }, null, 8, ["bundle", "dependentData"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.benefitsPaginate)
      ? (_openBlock(), _createElementBlock("img", _hoisted_87))
      : _createCommentVNode("", true),
    (!_ctx.allBenefitsWaived && _ctx.enrollmentType == 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["my-table-section benefit-section", { 'html2pdf__page-break': _ctx.paymentsPaginate }]),
          ref: "paymentsTable"
        }, [
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            (_ctx.modifyBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createElementVNode("a", {
                    class: "edit-pencil modalopen btn-link",
                    role: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirectPaymentPage()))
                  }, "Modify")
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_91,
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", _hoisted_96, " $" + _toDisplayString(_ctx.calculateAmountDue), 1),
                (
                _ctx.isStripeEnabled &&
                _ctx.amountTodayData?.payMethod === _ctx.common.paymentMethods.Card
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, " Includes $" + _toDisplayString(_ctx.convenienceFee) + " convenience fee ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["the-col", {
              'flex-2': !(
                _ctx.isStripeEnabled &&
                _ctx.amountTodayData?.payMethod === _ctx.common.paymentMethods.Card &&
                _ctx.cardDetail?.cardType
              ),
            }])
              }, [
                _hoisted_99,
                _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.getPaymentMethod("amountDueToday", _ctx.amountTodayData?.payMethod!)), 1)
              ], 2),
              (
              _ctx.isStripeEnabled &&
              _ctx.amountTodayData?.payMethod === _ctx.common.paymentMethods.Card &&
              _ctx.cardDetail?.cardType
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _hoisted_102,
                    _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.cardDetail?.cardType), 1)
                  ]))
                : _createCommentVNode("", true),
              (
              _ctx.isStripeEnabled &&
              _ctx.amountTodayData?.payMethod === _ctx.common.paymentMethods.Card &&
              _ctx.cardDetail?.cardType
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                    _hoisted_105,
                    _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.cardDetail?.last4), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.amountTodayData?.payMethod === _ctx.common.paymentMethods.ACH)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.amountTodayData?.routingNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _hoisted_112,
                    _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.amountTodayData?.bankName?.toLowerCase()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.amountTodayData?.accountNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.amountTodayData?.nameOnAccount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_120, [
                    _hoisted_121,
                    _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.getAccountType(_ctx.amountTodayData?.accountType!)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_123,
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("div", _hoisted_126, [
                _hoisted_127,
                _createElementVNode("div", _hoisted_128, " $" + _toDisplayString(_ctx.calculateMonthlyPremium), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["the-col", {
              'flex-2': !(
                _ctx.isStripeEnabled &&
                _ctx.amountTodayData?.payMethod === _ctx.common.paymentMethods.Card &&
                _ctx.cardDetail?.cardType
              ),
            }])
              }, [
                _hoisted_129,
                _createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.getPaymentMethod(
                  "monthlyPremium",
                  _ctx.monthlyPremiumData?.payMethod!
                )), 1)
              ], 2),
              (
              _ctx.isStripeEnabled &&
              _ctx.monthlyPremiumData?.payMethod === _ctx.common.paymentMethods.Card &&
              _ctx.cardDetail?.cardType
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                    _hoisted_132,
                    _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.cardDetail?.cardType), 1)
                  ]))
                : _createCommentVNode("", true),
              (
              _ctx.isStripeEnabled &&
              _ctx.monthlyPremiumData?.payMethod === _ctx.common.paymentMethods.Card &&
              _ctx.cardDetail?.cardType
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                    _hoisted_135,
                    _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.cardDetail?.last4), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.monthlyPremiumData?.payMethod === _ctx.common.paymentMethods.ACH)
              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _hoisted_139,
                    _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.monthlyPremiumData?.routingNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _hoisted_142,
                    _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.monthlyPremiumData?.bankName?.toLowerCase()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_144, [
                    _hoisted_145,
                    _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.monthlyPremiumData?.accountNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _hoisted_148,
                    _createElementVNode("div", _hoisted_149, _toDisplayString(_ctx.monthlyPremiumData?.nameOnAccount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _hoisted_151,
                    _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.getAccountType(_ctx.monthlyPremiumData?.accountType!)), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.monthlyPremiumData?.payMethod === _ctx.common.paymentMethods.Invoice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                  _createElementVNode("div", _hoisted_154, [
                    _hoisted_155,
                    _createElementVNode("div", _hoisted_156, _toDisplayString(_ctx.getMonthlyCountryName), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["the-col", {
              'flex-4': _ctx.monthlyPremiumData?.billingCountryId === _ctx.countries?.OTH,
            }])
                  }, [
                    _hoisted_157,
                    _createElementVNode("div", {
                      class: "the-value",
                      innerHTML: 
                _ctx.formatAddress(
                  _ctx.monthlyPremiumData.billingAddress1!,
                  _ctx.monthlyPremiumData.billingAddress2!
                )
              
                    }, null, 8, _hoisted_158)
                  ], 2),
                  (_ctx.monthlyPremiumData.billingCountryId !== _ctx.countries.OTH)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                        _hoisted_160,
                        _createElementVNode("div", _hoisted_161, _toDisplayString(_ctx.monthlyPremiumData.billingCity), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.monthlyPremiumData.billingCountryId !== _ctx.countries.OTH)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                        _hoisted_163,
                        _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.getMonthlyStateName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.monthlyPremiumData.billingCountryId !== _ctx.countries.OTH)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                        _hoisted_166,
                        _createElementVNode("div", _hoisted_167, _toDisplayString(_ctx.monthlyPremiumData.billingZipCode), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.paymentsPaginate && !_ctx.allBenefitsWaived)
      ? (_openBlock(), _createElementBlock("img", _hoisted_168))
      : _createCommentVNode("", true),
    (!_ctx.allBenefitsWaived)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: _normalizeClass(["my-table-section documents", { 'html2pdf__page-break': _ctx.documentsPaginate }]),
          ref: "documentsTable"
        }, [
          _createElementVNode("div", _hoisted_169, [
            _hoisted_170,
            (_ctx.modifyBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                  _createElementVNode("a", {
                    class: "edit-pencil modalopen btn-link",
                    role: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectDocumentsPage()))
                  }, "Modify")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_172, [
            (!_ctx.documentsData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_173, " No documents found. "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentsData, (documents) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "doc-box",
                key: documents.electionUploadId
              }, [
                _createElementVNode("div", _hoisted_174, [
                  _createElementVNode("img", {
                    alt: documents.fileName!,
                    src: 
                require(`/src/assets/images/${_ctx.getExtIcon(
                  documents.contentType!
                )}`)
              
                  }, null, 8, _hoisted_175)
                ]),
                _createElementVNode("div", _hoisted_176, [
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("div", _hoisted_178, _toDisplayString(documents.fileName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_179, [
                    _createElementVNode("div", _hoisted_180, _toDisplayString(_ctx.formatBytes(documents.fileSize!)), 1),
                    _hoisted_181
                  ])
                ])
              ]))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}